import { render, staticRenderFns } from "./ShopBindMomo.vue?vue&type=template&id=23a7a06b&scoped=true&"
import script from "./ShopBindMomo.vue?vue&type=script&lang=js&"
export * from "./ShopBindMomo.vue?vue&type=script&lang=js&"
import style0 from "./ShopBindMomo.vue?vue&type=style&index=0&id=23a7a06b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7a06b",
  null
  
)

export default component.exports